import { RichTextArea } from '@app/ui';
import { useGetEncounterOverviewQuery } from '@app/medical-record/api';
import { useTranslation } from 'react-i18next';

export interface EncounterOverviewWidgetProps {
  id: string;
}

export function EncounterOverviewWidget(props: EncounterOverviewWidgetProps) {
  const { id } = props;
  const { t } = useTranslation(undefined, { keyPrefix: 'encounters' });
  const { currentData: encounter } = useGetEncounterOverviewQuery({ id });

  if (!encounter || !encounter.note) {
    return null;
  }

  return (
    <>
      <div className="font-semibold mt-4 mb-2">{t('note.title')}</div>
      <RichTextArea readonly initialValue={encounter.note} />
    </>
  );
}
